import { render, staticRenderFns } from "./WizardStep2.vue?vue&type=template&id=b045d898&scoped=true"
import script from "./WizardStep2.vue?vue&type=script&lang=js"
export * from "./WizardStep2.vue?vue&type=script&lang=js"
import style0 from "./WizardStep2.vue?vue&type=style&index=0&id=b045d898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b045d898",
  null
  
)

export default component.exports